import { generateApiPath } from '@taxfix/scouts-helpers'

import { setUnregisteredUserToken } from '@/helpers/unregistered-user'
import { MarketingUserDTO } from '@/models'
import { UnregisteredUserDTO } from '@/models/unregistered-user'

import { apiSlice } from '../api-slice'
import { ENDPOINTS } from '../endpoints'
import { getExtraProfileCookieData } from '../profile/helpers'
import { Tags } from '../tags'
import { unregisteredUserBaseQuery } from './query'

const extendedApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createUnregisteredUser: builder.mutation<UnregisteredUserDTO, void>({
            queryFn: async (_, api, extraOptions) => {
                const extraCookieData = getExtraProfileCookieData()

                const response = await unregisteredUserBaseQuery(
                    {
                        url: generateApiPath(ENDPOINTS.UNREGISTERED_USER.POST.CREATE_UNREGISTERED_TOKEN),
                        method: 'POST',
                        body: extraCookieData,
                    },
                    api,
                    extraOptions
                )

                if (response.error) return { error: response.error }

                const result = response.data as UnregisteredUserDTO
                const { accessToken } = result

                if (accessToken !== null) setUnregisteredUserToken(accessToken)

                return { data: result }
            },
        }),
        getUnregisteredUser: builder.query<MarketingUserDTO, void>({
            queryFn: async (_, api, extraOptions) => {
                const response = await unregisteredUserBaseQuery(
                    {
                        method: 'GET',
                        url: generateApiPath(ENDPOINTS.UNREGISTERED_USER.GET),
                    },
                    api,
                    extraOptions
                )

                if (response.error) return { error: response.error }

                return { data: response.data as MarketingUserDTO }
            },
            providesTags: [Tags.UnregisteredUser],
        }),
        updateUnregisteredUser: builder.mutation<MarketingUserDTO, MarketingUserDTO>({
            queryFn: async (params, api, extraOptions) => {
                const response = await unregisteredUserBaseQuery(
                    {
                        method: 'PUT',
                        url: generateApiPath(ENDPOINTS.UNREGISTERED_USER.PUT),
                        body: params,
                    },
                    api,
                    extraOptions
                )

                if (response.error) return { error: response.error }

                return { data: response.data as MarketingUserDTO }
            },
            invalidatesTags: [Tags.UnregisteredUser],
        }),
        generateUnregisteredHotLead: builder.mutation<void, { phoneNumber: string }>({
            queryFn: async ({ phoneNumber }, api, extraOptions) => {
                const response = await unregisteredUserBaseQuery(
                    {
                        method: 'POST',
                        url: generateApiPath(ENDPOINTS.UNREGISTERED_USER.POST.HOT_LEAD),
                        body: { phoneNumber },
                    },
                    api,
                    extraOptions
                )

                if (response.error) return { error: response.error }

                return { data: response.data as void }
            },
        }),
    }),
})

export const {
    useCreateUnregisteredUserMutation,
    useGetUnregisteredUserQuery,
    useUpdateUnregisteredUserMutation,
    useGenerateUnregisteredHotLeadMutation,
} = extendedApi
